export enum DealRecapSectionsLabels {
    FRONTEND_PROFIT = 'Front End Profit',
    BACKEND_PROFIT = 'Back End Profit',
    GROSS_PROFIT = 'Gross Profit'
}

export const FrontendProfitSchema: Record<string, string>[] = [
    { label: 'Vehicle Price', value: 'retailPrice' },
    { label: 'Vehicle Cost', value: 'vehicleCost' },
    { label: 'Accessories', value: 'totalAccessoriesPrice' },
    { label: 'Accessories Cost', value: 'totalAccessoriesCost' },
    { label: 'Adds to Cost', value: 'addsToFrontEndCost' },
    { label: 'Trade', value: 'netTrade' },
    { label: 'ACV Over/Under', value: 'tradeAcb' },
    { label: 'Trade Allowance', value: 'totalAllowance' },
    { label: 'Dealer Cash', value: 'costReductionFromDealerCash' },
    { label: 'Lender Discounts', value: 'lenderDiscount' },
    { label: 'Products - Front Price', value: 'totalFrontEndProtectionProductsPrice' },
    { label: 'Products - Front Cost', value: 'totalFrontEndProtectionProductsCost' },
    { label: 'Total Front End Profit', value: 'frontEndProfit' }
];

export const ReserveSchema: Record<string, string>[] = [
    {
        label: 'Flat Fee',
        value: 'flatFee'
    },
    {
        label: 'Reserve Percent',
        value: 'reservePercentOfAmountFinanced',
        unit: '%'
    },
    {
        label: 'Power Flat',
        value: 'reservePaidOnPercentOfAmountFinanced'
    },
    {
        label: 'Split Percentage',
        value: 'reservePaid',
        unit: '%'
    },
    {
        label: 'Split Amount',
        value: 'reserveFromInterestParticipation'
    }
];
export const BackendProfitSchema: Record<string, string | Record<string, string>[]>[] = [
    {
        label: 'Reserve',
        value: 'reserveProfit',
        children: ReserveSchema
    },
    {
        label: 'Reserve Profit',
        value: 'reserveProfit'
    },
    {
        label: 'Adds to Cost (Back)',
        value: 'addsToBackEndCost'
    },
    {
        label: 'Product - Back Price',
        value: 'totalBackEndProtectionProductsPrice'
    },
    {
        label: 'Products - Back Cost',
        value: 'totalBackEndProtectionProductsCost'
    },
    {
        label: 'Total Back End Profit',
        value: 'backEndProfit'
    }
];

export const GrossProfitSchema: Record<string, string>[] = [
    {
        label: 'Total Front End Profit',
        value: 'frontEndProfit'
    },
    {
        label: 'Total Back End Profit',
        value: 'backEndProfit'
    },
    {
        label: 'Total Gross Profit',
        value: 'grossProfit'
    }
];
